// --- Legacy hostname guard (must run BEFORE React renders) -----------------
// Mirrors the backend's 301 redirect from `radar-trucks.emergent.host` to
// the canonical custom domain. Catches users whose browsers load the HTML
// directly (email links, bookmarks, installed PWAs) so they're redirected
// before any UI renders. The dev preview hostname
// `radar-trucks.preview.emergentagent.com` is intentionally NOT matched and
// continues to work normally for development.
if (typeof window !== "undefined" && window.location.hostname === "radar-trucks.emergent.host") {
  window.location.replace(
    "https://thetrucktrackr.com" +
      window.location.pathname +
      window.location.search +
      window.location.hash
  );
}

import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "@/index.css";
import App from "@/App";

// OTA updater handshake (native only). Must run on EVERY launch as early as
// possible — if notifyAppReady() isn't called within appReadyTimeout the
// plugin assumes the freshly applied bundle is broken and rolls back.
if (Capacitor.isNativePlatform()) {
  import("@capgo/capacitor-updater")
    .then(({ CapacitorUpdater }) => CapacitorUpdater.notifyAppReady())
    .catch((e) => console.error("OTA notifyAppReady failed", e));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
